import {
  DeliveryConfigurationData,
  DeliveryDetails,
  DeliveryHistory,
  DeliveryProviderPrice,
  EstimatedDeliveryTimeElement,
  OrderCalculation,
} from "../entities/delivery.entities";
import { DeliverySourceType } from "../entities/delivery.entities";

export type DeliveryState = {
  history: DeliveryHistory | null;
  historyLoading: boolean;
  historyError: string | null;
  sourceType: DeliverySourceType;
  linkedOrderId: number | null;
  calculation: OrderCalculation | null;
  selectedProvider: DeliveryProviderPrice | null;
  providers: DeliveryProviderPrice[];
  providersLoading: boolean;
  deliveryConfigData: DeliveryConfigurationData | null;
  estimatedTimes: EstimatedDeliveryTimeElement[];
  currentDetail: DeliveryDetails | null;
  checkoutLoading: boolean;
  checkoutError: string | null;
};

export const initialDeliveryState: DeliveryState = {
  history: null,
  historyLoading: false,
  historyError: null,
  sourceType: "customer",
  linkedOrderId: null,
  calculation: null,
  selectedProvider: null,
  providers: [],
  providersLoading: false,
  deliveryConfigData: null,
  estimatedTimes: [],
  currentDetail: null,
  checkoutLoading: false,
  checkoutError: null,
};
